import React from 'react'
import {Route, Switch} from 'react-router-dom'
import ReportsEditPage from './pages/Edit'
import ReportsIndexPage from './pages/Index'
import ReportsScheduledPage from './pages/Scheduled'
import ReportsSettingsPage from './pages/Settings'
import ReportsShowPage from './pages/Show'

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/reports/settings" component={ReportsSettingsPage} />
      <Route exact path="/reports/scheduled" component={ReportsScheduledPage} />
      <Route exact path="/reports/new" component={ReportsEditPage} />
      <Route exact path="/reports/:id/edit" component={ReportsEditPage} />
      <Route exact path="/reports/:id" component={ReportsShowPage} />
      <Route exact path="/reports" component={ReportsIndexPage} />
    </Switch>
  )
}
